import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { makeStyles, Box } from "@material-ui/core";
import CalendarEventView from "../../views/mobile-frame/calendar/CalendarEventView";
import PullToRefresh from "react-simple-pull-to-refresh";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../context/auth/AuthContext";
import {
  getCalendarEventData,
  getCalendarEventDataSuccess,
  deleteCalendarEventData,
} from "../../store/calendar-event-page.store";
import LoadingBackdrop from "../../components/LoadingBackdrop";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    padding: "5px",
    alignItems: "center",
  },
}));

const CalendarEventContainer = ({ eklok }) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const history = useHistory();

  const { token } = useContext(AuthContext);

  const { calendarEventData, error, loading, deleteEventSuccess } = useSelector(
    (state) => {
      return state.calendarEvent;
    },
  );

  const [startDate, setStartDate] = useState(null);
  const [payloadBody, setPayloadBody] = useState({
    EVENT_START_DATE: null,
    EVENT_END_DATE: null,
  });

  const onRefresh = () =>
    new Promise((resolve, reject) => {
      dispatch(
        getCalendarEventData({
          token: token,
          eklok: eklok,
          body: { eklok: eklok, mqtt_payload: payloadBody },
        }),
      );
      resolve();
    });

  const handleDeleteEvent = (id) => {
    dispatch(
      deleteCalendarEventData({
        token: token,
        eklok: eklok,
        body: {
          eklok: eklok,
          mqtt_payload: {
            EVENT_ID: id,
          },
        },
      }),
    );
  };

  useEffect(() => {
    if (startDate) {
      const updatedPayload = {
        EVENT_START_DATE: new Date(startDate + "T00:00:00Z").getTime() / 1000,
        EVENT_END_DATE: new Date(startDate + "T23:59:59Z").getTime() / 1000,
      };

      console.log("payload", updatedPayload);

      setPayloadBody(updatedPayload);

      dispatch(
        getCalendarEventData({
          token: token,
          eklok: eklok,
          body: { eklok: eklok, mqtt_payload: updatedPayload },
        }),
      );
    } else {
      dispatch(getCalendarEventDataSuccess(calendarEventData));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDate, deleteEventSuccess, dispatch]);

  return (
    <PullToRefresh onRefresh={onRefresh} pullingContent={false}>
      {loading && <LoadingBackdrop />}
      <Box className={classes.container}>
        <CalendarEventView
          events={calendarEventData}
          loading={loading}
          error={error}
          onSetStartDate={setStartDate}
          onNewEventClick={() => {
            history.push("/app/add/calendar/event/" + eklok);
          }}
          onDeleteEvent={handleDeleteEvent}
        />
      </Box>
    </PullToRefresh>
  );
};

export default CalendarEventContainer;
